import { YesObject } from '@yes.technology/react-toolkit'

type ArgProps = string | YesObject[] | undefined | boolean

function getDisabledArrow(
  previous?: ArgProps,
  next?: ArgProps
): 'prev' | 'next' | undefined {
  if (!previous) return 'prev'
  if (!next) return 'next'
  return undefined
}

export default getDisabledArrow
